import { z } from 'zod';

export interface CommerceSettingsApi {
  id: string;
  key: string;
  value: string;
  longValue: string;
  commerceId: string;
  commerceName?: string;
  dateValue?: string;
  numberValue?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CommerceSettings {
  id: string;
  key: string;
  value: string;
  longValue: string;
  commerceId: string;
  commerceName?: string;
  dateValue?: string;
  numberValue?: number;
  createdAt: string;
  updatedAt: string;
}

export interface NewCommerceSettings {
  key: string;
  value: string;
  longValue: string;
  commerceId: string;
  dateValue?: string;
  numberValue?: number;
}

export interface UpdateCommerceSettings {
  key?: string;
  value?: string;
  longValue?: string;
  dateValue?: string;
  numberValue?: number;
  commerceId?: string;
}

export interface CommerceSettingsFilters {
  key?: string;
  value?: string;
  longValue?: string;
  commerceId?: string;
  dateValue?: string;
  numberValue?: number;
}

export const commerceSettingsSchema = z.object({
  key: z
    .string()
    .min(1, 'La clave es requerida')
    .max(100, 'La clave no puede exceder 100 caracteres')
    .regex(
      /^[a-zA-Z0-9_]+$/,
      'La clave solo puede contener letras, números y guiones bajos'
    ),
  value: z
    .string()
    .min(1, 'El valor es requerido')
    .max(100, 'El valor no puede exceder 100 caracteres'),
  longValue: z
    .string()
    .min(1, 'El valor detallado es requerido')
    .max(15000, 'El valor detallado no puede exceder 15000 caracteres'),
  commerceId: z.string().min(1, 'El comercio es requerido'),
  dateValue: z
    .union([z.string(), z.date()])
    .optional()
    .transform((val) => {
      if (val === '' || val === undefined || val === null) {
        return undefined;
      }
      if (val instanceof Date) {
        return val.toISOString();
      }
      return val;
    }),
  numberValue: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => {
      if (val === '' || val === undefined || val === null) {
        return undefined;
      }
      const num = typeof val === 'string' ? parseFloat(val) : val;
      return isNaN(num) ? undefined : num;
    })
    .refine((val) => val === undefined || val >= 0, {
      message: 'El valor numérico debe ser mayor o igual a 0',
    }),
});

export const updateCommerceSettingsSchema = commerceSettingsSchema
  .partial()
  .omit({
    commerceId: true,
  });

export type CommerceSettingsSchema = z.infer<typeof commerceSettingsSchema>;
export type UpdateCommerceSettingsSchema = z.infer<
  typeof updateCommerceSettingsSchema
>;

export const defaultCommerceSettingsValues: CommerceSettingsSchema = {
  key: '',
  value: '',
  longValue: '',
  commerceId: '',
  dateValue: '',
  numberValue: undefined,
};
